import React from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'router'

import { useUser } from 'store'
import { toast } from 'components/global/CUK/Toast/Toast'
import CardActionButton from 'components/global/CardActions/CardActionButton'
import { trackEvent } from 'analytics'

const ActionEdit = ({ contact }) => {
  const [user] = useUser()
  const { t } = useTranslation()
  const navigate = useNavigate()

  const handleClick = () => {
    if (contact.sf_id === user.sf_contact_id) {
      toast.error(t('auth.admin.edit.self_contact_error'));
    } else {
      trackEvent('user_edit')
      navigate({ pathname: `/contacts/edit/${contact.sf_id}` })
    }
  }
  return (
    <CardActionButton
      iconlabel={'pen'}
      tooltiptitle={t('auth.admin.edit.label')}
      onClick={handleClick}
    />
  )
}

export default ActionEdit
